import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { STATE_USER } from '../consts';
import type { EDSKey, UserModels } from '../types';

const initialState = {
  accessToken: null,
  isAuthenticated: false,
  refreshToken: null,
  selectedEDS: null,
  soliqAccessToken: null,
  user: null,
};

export const useUserDataStore = create<UserDataStore>()(
  persist(
    (set, get) => ({
      ...initialState,
      resetUserDataStore: () => set({ ...initialState }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
      setRefreshToken: (refreshToken) => set({ refreshToken }),
      setSelectedEDS: (selectedEDS) => {
        set({ selectedEDS: selectedEDS });
      },
      setSoliqAccessToken: (soliqAccessToken) => {
        set({ soliqAccessToken: soliqAccessToken });
      },
      setUser: (user) => {
        set({ user: user });
      },
    }),
    {
      name: STATE_USER,
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export type UserDataStore = Actions & State;

interface Actions {
  resetUserDataStore: () => void;
  setAccessToken: (accessToken: null | string) => void;
  setAuthenticated: (isAuthenticated: boolean) => void;
  setRefreshToken: (refreshToken: string) => void;
  setSelectedEDS: (selectedEDS: EDSKey | null) => void;
  setSoliqAccessToken: (soliqAccessToken: null | string) => void;
  setUser: (user: UserModels.User) => void;
}

interface State {
  accessToken: null | string;
  isAuthenticated: boolean;
  refreshToken: null | string;
  selectedEDS: EDSKey | null;
  soliqAccessToken: null | string;
  user: null | UserModels.User;
}
